import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdalService } from '../adal/adal.service';
import { UserInfoService } from '../services/userinfo.service';
//import { AdConfigService } from '../services/adconfig.service';
//import { DataService } from '../services/DataService';
//import { AppSettingsService } from '../services/appsettings.service';
//import { HomeService } from '../services/home.service'

@Component({
    selector: 'adminnavigation',
    template: require('./admin.navigation.component.html')
    //providers: [AdalService]
})

export class AdminNavigationComponent implements OnInit {

    public message: string;
    public values: any[];
    public userInfo: any;

    constructor(
        private adalService: AdalService,
        //private adConfigService: AdConfigService,
        //private appSettingsService: AppSettingsService,
        private userInfoService: UserInfoService,
        private router: Router) {
        //this.adalService.init(this.appSettingsService.adalConfig);
        //this.userInfo = this.adalService.userInfo;
    }

    ngOnInit() {
        //this._dataService
        //    .GetAll()
        //    .subscribe(data => this.values = data,
        //    error => console.log(error),
        //    () => console.log('Get all complete'));
        this.userInfo = this.adalService.userInfo;
    }

    public updateUserInfo(userInfo: any) {
        //this.userInfo = userInfo
    }

    public login() {
        this.adalService.login();
    }

    public logout() {
        //this.homeService.LogOut();
        this.adalService.clearCache();//.logOut();
        this.adalService.logOut();
        //window.location.href = "/signout";
        //this.router.navigate(["/signout"]);
    }
}


// WEBPACK FOOTER //
// ./app/admin/admin.navigation.component.ts